import type { OnClickCallback } from '@atlaskit/editor-common/card';
import type { LinkPickerOptions } from '@atlaskit/editor-common/types';
import type { HyperlinkPluginOptions } from '@atlaskit/editor-plugin-hyperlink';

interface Props {
	options: {
		linkPicker: LinkPickerOptions | undefined;
		onClickCallback: OnClickCallback | undefined;
	};
}

export function hyperlinkPluginOptions({ options }: Props): HyperlinkPluginOptions {
	return {
		editorAppearance: 'full-page',
		lpLinkPicker: true,
		linkPicker: options.linkPicker,
		onClickCallback: options.onClickCallback,
		platform: 'web',
	};
}
